function Nothing() {
  return null;
}

export { Nothing };
